import {
  initOtelBrowser,
  initSentryBrowser,
  initAnalytics as packageInitAnalytics,
  startWebVitalsReporting
} from '@tandemone/observability/browser'

export function initOtel(config: { appEnv: string; appVersion: string }): void {
  initOtelBrowser({
    serviceName: 'tandemone-web',
    appEnv: config.appEnv,
    appVersion: config.appVersion,
    disabled: config.appEnv === 'test'
  })
  if (config.appEnv !== 'test') {
    startWebVitalsReporting()
  }
}

export function initSentry(config: {
  dsn: string | null
  appEnv: string
  appVersion: string
}): void {
  initSentryBrowser({
    dsn: config.dsn,
    appEnv: config.appEnv,
    appVersion: config.appVersion,
    disabled: config.appEnv === 'test'
  })
}

export function initAnalytics(config: { appEnv: string }): void {
  packageInitAnalytics({ disabled: config.appEnv === 'test' })
}
